import React from 'react'
import Button from './button'
import useCourseDrop from './use-course-drop'
import useCurrentUser from '../../../hooks/use-current-user'
import useCourseDropability from './use-course-dropability'

const DropButton = ({
    experience = {},
    onDropped = () => {}
}) => {
    const { drop } = useCourseDrop({ courseId: experience.id, onSuccess: onDropped })
    const { isStudent } = useCurrentUser()
    const { dropable } = useCourseDropability({ courseId: experience.id})
    
    if (!isStudent || !dropable) {
        return null
    }

    return (
        <Button
            onClick = {() => drop()}
        >
            DROP THIS EXPERIENCE
        </Button>
    )
}

export default DropButton